<template>
<div class="charts charts--nav">
    <div class="charts__nav compare-navigation">
        <div class="compare-navigation__title">Инструменты</div>
        <div class="compare-navigation__wrap">
            <div class="compare-navigation__item" v-for="(item,index) in pair" :key="index">
                <div class="compare-navigation__item-title">{{item.title}}</div>
                <div class="compare-navigation__item-data">
                    <div class="compare-navigation__item-data-balance">$ {{(item.equity).toLocaleString('ru')}}</div>
                    <div class="compare-navigation__item-data-profit">{{item.delta.toFixed(2)}}%</div>
                </div>
                <switcher @switchStatus = "switchSelector($event,index)"
                    :activeColor="item.colorSwitcher"
                    :classSwitcher="item.status">
                </switcher>
            </div>
        </div>
    </div>
    <div class="charts__body chart">
        <div class="chart__title charts-title" style="border-radius: 0px">Текущий доход</div>
		<div class="chart__item chart__item--h100 echarts">
			<div class="chart__info chart__inf-wrap">
				<div class="chart__inf-section-one">
					<div class="chart__inf-wrap-item">
						<close-stat></close-stat>
					</div>
				</div>
			</div>

			<compare-chart v-if="show"
				:showSelectorEURUSD="pair[0].status"
				:showSelectorGBPUSD="pair[1].status"
				:showSelectorUSDJPY="pair[2].status"
				:showSelectorEURGBP="pair[3].status"
				:showSelectorUSDCAD="pair[4].status"
				:showSelectorUSDCHF="pair[5].status"
				:update="update"
				:updateHight="updateHight"
				:updateRight="updateRight"
				:resize="resize"
				@onStatisticReady = "onEquityByPair($event)">
			</compare-chart>
		</div>
	</div>
</div>
</template>
<script>
import CompareChart from './sig-compare-profitability-chart'
import Switcher from '../../ui-components/switcher'
import CloseStat from './sig-close-positions-on-compare'
import { mapGetters } from "vuex";
export default {
    props : {
        update:{default:true},
        updateHight:{default:true},
        updateRight:{default:true},
        resize:{default:true}
    },
    data() {
        return {
            pair : [
                {
                    title:'EURUSD',
                    symbol:'EURUSD',
                    colorSwitcher:'blue',
                    status:true,
                    colorArea:1,
                    equity:0,
                    delta:0
                },
                {
                    title:'GBPUSD',
                    symbol:'GBPUSD',
                    colorSwitcher:'green',
                    colorArea:2,
                    status:true,
                    equity:0,
                    delta:0
                },
                {
                    title:'USDJPY',
                    symbol:'USDJPY',
                    colorSwitcher:'purple',
                    colorArea:3,
                    status:true,
                    equity:0,
                    delta:0
                },
                {
                    title:'EURGBP',
                    symbol:'EURGBP',
                    colorSwitcher:'orange',
                    colorArea:3,
                    status:true,
                    equity:0,
                    delta:0
                },
                {
                    title:'USDCAD',
                    symbol:'USDCAD',
                    colorSwitcher:'yellow',
                    colorArea:3,
                    status:true,
                    equity:0,
                    delta:0
                },
                {
                    title:'USDCHF',
                    symbol:'USDCHF',
                    colorSwitcher:'fiolet',
                    colorArea:3,
                    status:true,
                    equity:0,
                    delta:0
                }
            ],
            selector949:true,
            selectorEURUSD:true,
			show:true
        }
    },
    components : {
        'compare-chart':CompareChart,
        'switcher':Switcher,
        'close-stat':CloseStat
    },
    methods : {
        switchSelector(status,index){
            this.pair[index].status = status
        },
        onEquityByPair(equity) {
            for(let i = 0; i < this.pair.length; i++)
            {
                this.pair[i].equity = equity[i].equity
                this.pair[i].delta = equity[i].delta
            }
        }
    },
    computed : {

    }
}
</script>
<style lang="less" scoped>
.compare-navigation {
    min-width: 240px;
    background-color: #3d536b;
    margin-right: 1px;
    overflow: auto;

    &__wrap {
        display: block;
        overflow: auto;
    }

    &__title {
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.08;
        letter-spacing: 0.4px;
        color: #ffffff;
        text-transform: uppercase;
        padding-left: 12px;
    }

    &__item {
        display: flex;
        padding: 12px;
        justify-content: space-between;
        align-items: center;
        border-top: 1px  solid #324258;
        &:last-child {
           border-bottom: 1px  solid #324258;
        }

        &:hover {
            background: #506b89;
        }

        &-title {
            font-family: Arimo;
            font-size: 13px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3.08;
            letter-spacing: 0.4px;
            color: #ffffff;
            text-transform: uppercase;
        }

        &-data {
            &-balance {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.23;
                letter-spacing: 0.4px;
                color: @colors[green];
            }

            &-profit {
                opacity: 0.9;
                font-family: Arimo;
                font-size: 11px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.45;
                letter-spacing: 0.4px;
                color: #0fd7b7;
            }
        }

        &-switcher {
            display: inline-block;
            width: 23px;
            height: 14px;
            border-radius: 19px;
            z-index: 0;
            margin: 0;
            padding: 0;
            border: 2px solid #718da8;
            cursor: pointer;
            position: relative;
            transition-duration: 300ms;

            &::after {
                content: "";
                height: 10px;
                width: 10px;
                border-radius: 17px;
                background: #718da8;
                top: 2px;
                left: 2px;
                transition-duration: 300ms;
                position: absolute;
                z-index: 1;
            }
        }

        &-switcher-on {
            border: 2px solid #36e2ff;

            &::after
            {
                left: 11px;
                background: #36e2ff;
            }

			&-green {
				border: 2px solid @colors[green];

				&:after {
					background-color: @colors[green];
					top: 2px;
					left: 11px !important;
				}
			}
        }
    }
}

.chart__inf-wrap {
  padding: 12px 12px 12px 12px;
  //display: flex;
  justify-content: space-between;
  position: absolute;
  z-index: 1;
}

.chart {
	background-color: @colors[lightgrey];

	&__item {
		background-image: linear-gradient(to top, rgba(54, 226, 255, 0.4), rgba(0, 175, 255, 0));
	}
}

</style>

